import * as React from 'react';
import classnames from '../utils/classnames.tsx';

interface TabButtonProps extends React.ComponentPropsWithRef<'button'> {
    isActive?: boolean;
}

const TabButton = ({ isActive, className, ...props }: TabButtonProps) => (
    <button
        {...props}
        className={classnames(
            'border-b-2 border-solid border-line-transparent flex items-center justify-center gap-2 px-3 py-4 font-medium text-sm text-content-strong transition-colors cursor-pointer',
            'hover:border-line-hover hover:text-content-strong',
            isActive && '!border-line-brand-focus !text-content-brand-strong',
            className
        )}
    />
);

export default TabButton;
